import React from "react";
import styles from "../specialities.module.css";
import SpecialitiesBanner from "../../../components/Banners/Speacialities-Banner/speacialities-banner";
import ImageWithText from "../../../components/ImageWithText/ImageWithText";
import SpecialityFeatures from "../../../components/SpecialityFeatures/specialityFeatures";
import TextOnly from "../../../components/TextOnly/textOnly";
import MetaTags from "../../../components/MetaTags";

const RoleManagement = () => {
  const bannerContent = {
    heading: "Role Management Solutions",
    subText: (
      <>
      Effective role management is crucial for any scalable business solution. At Ninjas Code, our Role Management feature allows you to define, assign, and manage roles within your organization with precision. Keep your systems running with secure and efficient solutions that are easy to understand for your staff and users.
</>
    ),
  };

  const specialityAbout = [
    {
      aboutImage: {
        url: "assets//Speciality-Images/Custom-Role-Creation.webp",
        alt: "Custom Role Creation",
      },
      aboutTitle: { title: `Custom Role Creation`, highlightedTitle: "" },
      aboutDescription: (
        <>
Create and customize roles to fit your business structure, from administrators and managers to vendors and delivery personnel.</>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Role-Based-Access-Control.webp",
        alt: "Role-Based Access Control (RBAC)",
      },
      aboutTitle: { title: `Role-Based Access Control (RBAC)`, highlightedTitle: "" },
      aboutDescription: (
        <>
Secure your platform by assigning specific permissions to each role, ensuring users only access what they need.</>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Simplified-Onboarding.webp",
        alt: "Simplified Onboarding",
      },
      aboutTitle: { title: `Simplified Onboarding`, highlightedTitle: "" },
      aboutDescription: (
        <>
Quickly onboard team members or vendors by assigning predefined roles, minimizing setup time.</>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Enhanced-Security-2.webp",
        alt: "Enhanced Security",
      },
      aboutTitle: { title: `Enhanced Security`, highlightedTitle: "" },
      aboutDescription: (
        <>
Reduce the risk of unauthorized access and data breaches with carefully managed user permissions.</>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Real-Time-Role-Updates.webp",
        alt: "Real-Time Role Updates",
      },
      aboutTitle: { title: `Real-Time Role Updates`, highlightedTitle: "" },
      aboutDescription: (
        <>
Easily adjust roles and permissions as your team grows or operational needs evolve.</>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Audit-Logs-and-Insights.webp",
        alt: "Audit Logs and Insights",
      },
      aboutTitle: { title: `Audit Logs and Insights`, highlightedTitle: "" },
      aboutDescription: (
        <>
Track user activities and access history for compliance and performance monitoring.</>
      ),
      flexReverse: "true",
    },
  ];

  const featurePoints = [
    <>Unlimited custom roles and permissions</>,
    <>Role templates for common business needs</>,
    <>Dynamic role updates for evolving requirements</>,
    <>Seamless integration with existing workflows</>,
    <>Detailed reporting on role-based activities</>
  ];

  const finalThoughts = [
    {heading: `Take Control of Your Operations`},
    {subText: `Ninjas Code’s Role Management solution empowers you to maintain a well-organized and secure system, giving your team the freedom to focus on what they do best. Contact us today to discover how we can customize this feature for your business!`},
  ]

  return (
    <div>
       <MetaTags
     title="Role Management Solutions for Secure Business Operations"
     description="Ninjas Code Role management keeps your operations running smoothly. Optimize team workflows with customizable roles and audit logs. Get a solution now!"
     />
      <SpecialitiesBanner content={bannerContent} />

      <div className={styles.specialitiesAbout}>
        <div className={styles.container}>
          <h2>Why Choose Our Role Management Solution?</h2>
          <ImageWithText aboutContent={specialityAbout} />
        </div>
      </div>

      <SpecialityFeatures features={featurePoints} />

      <TextOnly 
      content={finalThoughts}
      width
      />
    </div>
  );
};

export default RoleManagement;
